import { CONTACT_ASSOCIATION_ID } from "../modules/shared/constants/typeId"

export const ACCOUNT_ID = CONTACT_ASSOCIATION_ID.ACCOUNT
export const LEAD_ID = CONTACT_ASSOCIATION_ID.LEAD
export const ORGANIZATION_ID = CONTACT_ASSOCIATION_ID.ORGANIZATION
export const VENDOR_ID = CONTACT_ASSOCIATION_ID.VENDOR
